<template>
  <v-row
    id="home-page"
    justify="center"
    align="center">
    <v-col
      v-if="!userData || isLogout"
      cols="auto">
      <h1 class="mb-5">
        กรุณา Login
      </h1>
      <div class="text-center">
        <v-btn
          color="primary"
          :to="{
            name: 'Login'
          }">
          Login
        </v-btn>
      </div>
    </v-col>

    <v-col
      v-else
      cols="auto">
      <h1 class="text-center mb-10">
        ยินดีต้อนรับ คุณ
      </h1>
      <v-avatar
        class="mx-auto d-block"
        size="62">
        <img
          :src="userData.picture"
          alt="user">
      </v-avatar>
      <h3 class="text-center mb-10">
        {{ userData.name }}
      </h3>

      <div class="text-center">
        <v-btn
          color="primary"
          :to="{
            name: 'FilteredList'
          }"
          :disabled="!checkRole">
          เข้าใช้งานระบบ
        </v-btn>
        <v-btn
          color="error"
          class="ml-2"
          @click="logout()">
          Logout
        </v-btn>
      </div>
      <p
        v-if="!checkRole"
        class="text-center error--text mt-5">
        * คุณไม่มีสิทธิ์ใช้งานระบบ
      </p>
    </v-col>
  </v-row>
</template>

<script>
import { getAuthDecode, clearAuth } from '@/assets/js/Authentication'

export default {
  data () {
    return {
      isLogout: false
    }
  },
  computed: {
    userData () {
      return getAuthDecode()
    },
    checkRole () {
      const { role } = this.userData
      return role === 'admin' || role === 'owner'
    }
  },
  methods: {
    logout () {
      clearAuth()
      this.isLogout = true
    }
  }
}
</script>

<style lang="scss" scoped>
#home-page {
  min-height: calc(100vh - 24px);
}
</style>
